import * as api from '../../data/api/api';

const REQUESTING_CONTENT = 'REQUESTING_CONTENT';
const SET_CONTENT = 'SET_CONTENT';

const initialState = {
  requesting: false,
  content: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTING_CONTENT:
      return {
        ...state,
        requesting: action.requesting,
      };

    case SET_CONTENT:
      return {
        ...state,
        content: action.data,
      };

    default:
      return state;
  }
};

const requestingContent = (requesting) => {
  return {
    type: REQUESTING_CONTENT,
    requesting,
  };
};

const setContent = (content) => {
  return {
    type: SET_CONTENT,
    data: content,
  };
};

const getContent = (filters = []) => (dispatch) => {
  dispatch(requestingContent(true));
  return api
    .listContents(filters)
    .then((content) => {
      dispatch(setContent(content.data));
      dispatch(requestingContent(false));
    });
};

export const actions = {
  requestingContent,
  setContent,
  getContent,
};
